<!-- edit-brand.component.html -->
<div class="brand-form-container">
  
  <!-- Loading Spinner -->
  <div *ngIf="isLoading || isUpdating" class="loading-overlay">
    <div class="loading-spinner">
      <div class="spinner"></div>
      <p class="loading-text">{{ loadingMessage }}</p>
    </div>
  </div>

  <div class="form-header">
    <h1>تعديل البراند</h1>
    <p>قم بتعديل بيانات البراند في النموذج أدناه</p>
    <div class="brand-id" *ngIf="isFormLoaded()">
      <span class="id-badge">معرّف البراند: {{ currentBrandId }}</span>
    </div>
  </div>

  <form [formGroup]="brandForm" class="brand-form" [class.loading]="isLoading || isUpdating">
    
    <div class="form-section" *ngIf="isFormLoaded()">
      <h2>المعلومات الأساسية</h2>
      
      <div class="form-row">
        <!-- الاسم العربي -->
        <div class="form-group" [class.error]="isFieldInvalid('arName')">
          <label for="arName">الاسم بالعربية *</label>
          <input 
            type="text" 
            id="arName"
            formControlName="arName" 
            placeholder="أدخل الاسم باللغة العربية"
            [class.error]="isFieldInvalid('arName')"
            [disabled]="isLoading || isUpdating"
          />
          <div class="error-message" *ngIf="isFieldInvalid('arName')">
            ⚠️ {{ getFieldError('arName') }}
          </div>
        </div>

        <!-- الاسم الإنجليزي -->
        <div class="form-group" [class.error]="isFieldInvalid('enName')">
          <label for="enName">الاسم بالإنجليزية *</label>
          <input 
            type="text" 
            id="enName"
            formControlName="enName" 
            placeholder="أدخل الاسم باللغة الإنجليزية"
            [class.error]="isFieldInvalid('enName')"
            [disabled]="isLoading || isUpdating"
          />
          <div class="error-message" *ngIf="isFieldInvalid('enName')">
            ⚠️ {{ getFieldError('enName') }}
          </div>
        </div>
      </div>

      <div class="form-row">
        <!-- الكود -->
        <div class="form-group" [class.error]="isFieldInvalid('code')">
          <label for="code">كود البراند *</label>
          <input 
            type="text" 
            id="code"
            formControlName="code" 
            placeholder="أدخل كود البراند"
            [class.error]="isFieldInvalid('code')"
            [disabled]="isLoading || isUpdating"
            (input)="validateCode()"
            style="text-transform: uppercase; font-family: monospace;"
          />
          <div class="error-message" *ngIf="isFieldInvalid('code')">
            ⚠️ {{ getFieldError('code') }}
          </div>
          <small class="form-text">
            كود مختصر للبراند (أرقام)
          </small>
        </div>

        <!-- الرابط (Slug) -->
        <div class="form-group" [class.error]="isFieldInvalid('slug')">
          <label for="slug">رابط البراند slug *</label>
          <input 
            type="text" 
            id="slug"
            formControlName="slug" 
            placeholder="slug أدخل رابط البراند"
            [class.error]="isFieldInvalid('slug')"
            [disabled]="isLoading || isUpdating"
            (input)="validateSlug()"
            style="font-family: monospace;"
          />
          <div class="error-message" *ngIf="isFieldInvalid('slug')">
            ⚠️ {{ getFieldError('slug') }}
          </div>
          <small class="form-text">رابط فريد للبراند (أحرف إنجليزية صغيرة، أرقام، وشرطة فقط)</small>
        </div>
      </div>

      <!-- اللوجو -->
<div class="form-group logo-upload" [class.error]="isFieldInvalid('logo') && submitted">
  <label for="logo">شعار البراند</label>

  <div class="logo-upload-area" [class.has-logo]="getLogoUrl() || logoPreview">

    <div class="upload-placeholder" *ngIf="!getLogoUrl() && !logoPreview">
      <i class="upload-icon">📁</i>
      <p>اختر شعار البراند من الجالري</p>
      <small>سيتم إرسال ID الصورة في حقل logo</small>

      <button
        type="button"
        class="btn-open-gallery"
        (click)="openGalleryModal()"
        [disabled]="isLoading || isUpdating"
      >
        اختيار من الجالري
      </button>
    </div>

    <div class="logo-preview" *ngIf="getLogoUrl() || logoPreview">
      <img
        [src]="logoPreview | ImageUrlPipe"
        alt="logo preview"
        appImageFallback
      >

      <button type="button" class="remove-logo" (click)="removeLogo()">×</button>

      <button
        type="button"
        class="btn-open-gallery change-logo-btn"
        (click)="openGalleryModal()"
        [disabled]="isLoading || isUpdating"
      >
        تغيير من الجالري
      </button>
    </div>
  </div>

  <div class="error-message" *ngIf="isFieldInvalid('logo') && submitted">
    ⚠️ {{ getFieldError('logo') }}
  </div>

  <small class="form-text" *ngIf="existingLogoUrl && !selectedFile">
    الشعار الحالي للبراند
  </small>
</div>

      <div class="form-row">
        <!-- براند مميز -->
        <div class="form-group status-group">
          <label for="top">براند مميز</label>
          <div class="status-toggle">
            <label class="toggle-switch">
              <input 
                type="checkbox" 
                id="top"
                formControlName="top"
                [disabled]="isLoading || isUpdating"
              />
              <span class="toggle-slider"></span>
            </label>
            <span class="status-text">
              {{ brandForm.get('top')?.value ? 'نعم' : 'لا' }}
            </span>
          </div>
          <small class="form-text">عرض هذا البراند في القسم المميز</small>
        </div>

        <!-- الحالة -->
        <div class="form-group status-group">
          <label for="status">حالة البراند</label>
          <div class="status-toggle">
            <label class="toggle-switch">
              <input 
                type="checkbox" 
                id="status"
                formControlName="status"
                [disabled]="isLoading || isUpdating"
              />
              <span class="toggle-slider"></span>
            </label>
            <span class="status-text">
              {{ brandForm.get('status')?.value ? 'مفعل' : 'معطل' }}
            </span>
          </div>
          <small class="form-text">تفعيل أو تعطيل هذا البراند</small>
        </div>
      </div>
    </div>

    <!-- رسالة عدم وجود بيانات -->
    <div class="no-data" *ngIf="!isFormLoaded() && !isLoading">
      <div class="no-data-content">
        <h3>⚠️ لا توجد بيانات</h3>
        <p>لم يتم العثور على بيانات البراند المطلوبة</p>
        <button type="button" class="btn-back" (click)="onCancel()">
          العودة للقائمة
        </button>
      </div>
    </div>

    <!-- أزرار التحكم -->
    <div class="form-actions" *ngIf="isFormLoaded()">
      <button 
        type="button" 
        class="btn-cancel" 
        (click)="onCancel()"
        [disabled]="isUpdating">
        إلغاء
      </button>
      
      <button 
        type="button" 
        class="btn-reset" 
        (click)="onReset()"
        [disabled]="isUpdating">
        إعادة التحميل
      </button>
      
      <button 
        type="button" 
        class="btn-save" 
        (click)="onSubmit()"
        [disabled]="isUpdating || !hasFormChanged()">
        <span *ngIf="!isUpdating">تحديث البراند</span>
        <span *ngIf="isUpdating">جاري التحديث...</span>
      </button>
    </div>
<div class="gallery-modal-backdrop" *ngIf="isGalleryModalOpen">
  <div class="gallery-modal">
    <div class="gallery-modal-header">
      <h3>اختيار شعار البراند</h3>

      <button
        type="button"
        class="close-modal-btn"
        (click)="closeGalleryModal()"
      >
        ×
      </button>
    </div>

    <div class="gallery-modal-body">
      <app-gallery-picker
        [selectedImages]="selectedPhotos"
        (selectedImagesChange)="onGalleryImagesChange($event)">
      </app-gallery-picker>
    </div>

    <div class="gallery-modal-footer">
      <button
        type="button"
        class="btn-cancel"
        (click)="closeGalleryModal()"
      >
        إغلاق
      </button>
    </div>
  </div>
</div>
  </form>
</div>